
import { ISelectOption } from 'app/interfaces/ISelectOption';

export const copyBehaviorOptionValues = {
    flattenHierarchy: 'FlattenHierarchy',
    mergeFiles: 'MergeFiles',
    preserveHierarchy: 'PreserveHierarchy'
};

export const copyBehaviorOptions: Array<ISelectOption<string>> = [
    {
        label: stringResources.CopyBehavior_Option_FlattenHierarchy,
        value: copyBehaviorOptionValues.flattenHierarchy
    },
    {
        label: stringResources.CopyBehavior_Option_MergeFiles,
        value: copyBehaviorOptionValues.mergeFiles,
        tooltip: stringResources.CopyBehavior_MergeFiles_HintMessage
    },
    {
        label: stringResources.CopyBehavior_Option_PreserveHierarchy,
        value: copyBehaviorOptionValues.preserveHierarchy
    }
];
